// BEI KLICK AUF HAMBURGER MAINNAV

let hamburger = document.querySelector('.iww-hamburger-spin');

if (hamburger !== null) {
    hamburger.addEventListener('click', function () {
        let ariaHidden = hamburger.getAttribute('aria-hidden');

        if (ariaHidden === 'true') {
            hamburger.setAttribute('aria-hidden', 'false');
        } else {
            hamburger.setAttribute('aria-hidden', 'true');
        }
    });
}

let urlPath = window.location.pathname;

// Main Nav Markiere Hauptseiten
const mainheader_seiten = document.querySelector("#iww-mainheader-seiten");

if (mainheader_seiten !== null) {
    mainheader_seiten.childNodes.forEach(seiten_button => {
        let href = seiten_button.firstChild.href;

        if (typeof href == 'undefined' && href == null) {
            return;
        }

        let linkUrl = new URL(href);
        if (linkUrl.pathname == "/" && urlPath == "/") {
            seiten_button.firstChild.classList = "group text-sm text-neutral-on-accent relative px-2.5 py-1 font-medium rounded-full border border-accent-border bg-accent-background";
        } else if (linkUrl.pathname !== "/" && urlPath.includes(linkUrl.pathname.substring(0, linkUrl.pathname.indexOf("/", 1) > -1 ? linkUrl.pathname.indexOf("/", 1) : linkUrl.pathname.length)) && window.location.host.includes(linkUrl.host.substring(0, linkUrl.host.indexOf(".")))) {
            seiten_button.firstChild.classList = "group text-sm text-neutral-on-accent relative px-2.5 py-1 font-medium rounded-full border border-accent-border bg-accent-background";
        }
    });
}

// Main Nav Markiere Infodienste
let infodiensteAbos = document.getElementById("iww-mainheader-loggedin-abos");

if (infodiensteAbos !== null && urlPath.includes("/infodienste")) {
    infodiensteAbos.childNodes.forEach(abo => {
        let linkUrl = new URL(abo.firstChild.href);

        if (urlPath.includes(linkUrl.pathname)) {
            abo.firstChild.classList = "group text-sm text-neutral-on-accent relative px-2.5 py-1 font-medium rounded-full border border-accent-border bg-accent-background";
        }
    });
}

// Main Nav Markiere Mein IWW
if (window.location.href.includes("kunden.iww.")) {
    let meinIwwLink = document.querySelector("a[href*='kunden.iww.'][href*='/meinbereich']");
    meinIwwLink.classList = "group text-base text-neutral-on-accent relative px-3 pt-2 pb-1.5 mr-2 font-medium rounded border border-accent-border bg-accent-background";
}
